export const buildProgressDashArr = (currentLevel, lowestPercentEarned, nbrDashes) => {
    let progressDashArr = [];
    let counter = 1
    while (counter <= currentLevel){
        // all levels prior to the 'currentLevel' have been earned
        progressDashArr.push(1);
        counter += 1;
    }
    const percentEarned = (+lowestPercentEarned / 100).toFixed(2);
    progressDashArr.push(+percentEarned);
    while (counter < nbrDashes){
        progressDashArr.push(0);
        counter += 1;
    }
    return progressDashArr;
}
export default buildProgressDashArr;
